/**
 * Krok 6: Kontakt (telefon, whatsapp, email, social, www)
 */
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Phone, Mail, Facebook, Instagram, Globe, MessageCircle, MessageSquare, CheckCircle2 } from 'lucide-react';

export default function Step6Contact({ data, updateData }) {
  const fields = [
    { key: 'phone', label: 'Telefon', icon: Phone, type: 'tel', placeholder: '+48 600 000 000' },
    { key: 'whatsapp', label: 'WhatsApp', icon: MessageSquare, type: 'tel', placeholder: '+48 600 000 000' },
    { key: 'messenger', label: 'Messenger', icon: MessageCircle, type: 'url', placeholder: 'm.me/twojahodowla' },
    { key: 'email', label: 'Email', icon: Mail, type: 'email', placeholder: 'kontakt@hodowla.pl' },
    { key: 'facebook', label: 'Facebook', icon: Facebook, type: 'url', placeholder: 'facebook.com/twojahodowla' },
    { key: 'instagram', label: 'Instagram', icon: Instagram, type: 'text', placeholder: '@twoja_hodowla' },
    { key: 'website', label: 'Strona WWW', icon: Globe, type: 'url', placeholder: 'https://twojahodowla.pl' },
  ];

  const filled = fields.filter((f) => data[f.key]?.trim()).length;

  return (
    <div className="space-y-6" data-testid="wizard-v2-step-contact">
      <header>
        <div className="flex items-center gap-2 mb-2">
          <div className="w-9 h-9 rounded-lg bg-orange-100 flex items-center justify-center">
            <Phone className="w-5 h-5 text-orange-500" />
          </div>
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 leading-tight">Jak klienci się z Tobą skontaktują?</h2>
        </div>
        <p className="text-gray-500 text-sm">
          Dodaj choć jeden sposób. Im więcej kanałów, tym łatwiej klientom napisać.
        </p>
      </header>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {fields.map(({ key, label, icon: Icon, type, placeholder }) => (
          <div key={key} className="space-y-1.5">
            <Label htmlFor={`c-${key}`} className="flex items-center gap-1.5 text-sm font-medium text-gray-700">
              <Icon className="w-4 h-4 text-orange-500" />
              {label}
            </Label>
            <Input
              id={`c-${key}`}
              type={type}
              value={data[key] || ''}
              onChange={(e) => updateData({ [key]: e.target.value })}
              placeholder={placeholder}
              data-testid={`wizard-v2-contact-${key}`}
              className="h-11 focus-visible:ring-orange-400"
            />
          </div>
        ))}
      </div>

      {filled > 0 && (
        <div className="rounded-xl bg-emerald-50 border border-emerald-200 p-3 flex items-center gap-2.5 text-sm text-emerald-900">
          <CheckCircle2 className="w-5 h-5 text-emerald-600 flex-shrink-0" />
          <span>
            <strong>{filled}</strong> {filled === 1 ? 'kanał kontaktu dodany' : 'kanałów kontaktu dodanych'}.
            {filled < 3 && ' Dodaj więcej dla lepszej konwersji.'}
          </span>
        </div>
      )}
    </div>
  );
}
